module.exports = __webpack_public_path__ + "9ddce4c5668e6142222b9e04aef71db6.png";